import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import MaleImage from '../../images/icons/male.svg';
import Female from '../../images/icons/UserKycIcons/female_icon.svg';
import CommonInput from '../Dashboard-res/CommonComponent/CommonInput';
import CommonDatePicker from '../Dashboard-res/CommonComponent/CommonDatePicker';
import get from 'lodash/get';
import CommonSelect from '../Dashboard-res/CommonComponent/CommonSelect';
import '../../containers/UserKyc/AadharPage/Aadhar.css';
import './AddCoApplicant.css';
import { createApplicant } from '../../common/constants/api';
import { getApplicantionInfo } from '../../common/utils/applicantionInfo';
import common_gender from '../../images/icons/UserKycIcons/common_gender.svg';
import InputPrefixDropdown from '../../common/components/InputPrefixDropdown/InputPrefixDropdown';
import {
  py2rem,
  md_py_0_25rem,
  py_0_5rem,
  py_2_5rem,
  md_py_0_75rem,
  md_py_0_5rem,
  py_0_75rem,
  py_6rem,
  py_0_25rem,
  mt_container,
  mt_1_9rem,
  sm_py_0_75rem,
  sm_py_1rem
} from './addCoApplicant.module.css';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  gender: Yup.string().required('Required'),
  firstName: Yup.string()
    .required('Required')
    .min(3, 'Too Short!'),
  lastName: Yup.string()
    .required('Required')
    .min(3, 'Too Short!'),
  mobile: Yup.number('numbers only')
    .typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .min(10, 'must be a 10 digit no')
    .required('A phone number is required'),
  relationship: Yup.string().required('Required'),
  date: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  month: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  year: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  email: Yup.string()
    .max(100, 'Email address is Too Long!')
    .required('Please Enter your email ID')
    .matches(
      /^([a-z 0-9\.-_]+)@([a-z 0-9-]+).([a-z]{2,8})(.[a-z]{2,8})?$/,
      'invalid email'
    )
});
const AddCoApplicant = props => {
  const [checked, setChecked] = useState(false);
  return (
    <Formik
      initialValues={{
        firstName: '',
        lastName: '',
        mobile: '',
        email: '',
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: '',
          label: 'Month'
        },
        year: {
          value: '2001',
          label: '2001'
        },
        gender: '',
        relationship: '',
        title: { label: 'Mr', value: 'Mr' }
      }}
      validationSchema={validationSchema}
      onSubmit={(data, { setSubmitting }) => {
        setSubmitting(true);
        let body = {
          name: {
            firstName: data.firstName,
            middleName: '',
            lastName: data.lastName
          },
          dob: new Date(
            `${data.year.value}-${data.month.value}-${data.date.value}`
          ),
          phone: data.mobile,
          email: data.email,
          gender: data.gender,
          relation: data.relationship.value,
          considerIncome: checked
        };
        let applicant = getApplicantionInfo();
        createApplicant(body, applicant.leadId)
          .then(() => {
            props.setShow(false);
            props.setApiCall(true);
            props.setpopUpType('success');
            props.setpopUpText('Co-Applicant has been added successfully!');
            props.setautoClose(false);
            props.setpopUpShow(true);
            setSubmitting(false);
          })
          .catch(error => {
            props.setShow(false);
            if (error.response) {
              props.setpopUpType('fail');
              props.setpopUpText(
                error?.response?.data?.message || 'Oops! Something went wrong!'
              );
              props.setautoClose(false);
              props.setpopUpShow(true);
              setSubmitting(false);
            }
          });
      }}
    >
      {({
        values,
        handleChange,
        errors,
        touched,
        handleBlur,
        setFieldError,
        setFieldValue,
        setFieldTouched,
        handleSubmit,
        isSubmitting
      }) => {
        const [Loading, setLoading] = useState(false);
        const [mobile, setMobile] = useState('');
        const inputLength = mobile.length;
        const handleCheckedChange = e => {
          setChecked(e.target.checked);
        };
        const relationShipFilter = [
          {
            label: 'Father',
            value: 'Father'
          },
          {
            label: 'Son',
            value: 'Son'
          },
          {
            label: 'Mother',
            value: 'Mother'
          },
          {
            label: 'Brother',
            value: 'Brother'
          },
          {
            label: 'Husband',
            value: 'Husband'
          },
          {
            label: 'Wife',
            value: 'Wife'
          },
          {
            label: 'Unmarried Daughter',
            value: 'Unmarried Daughter'
          }
        ];
        let titleOptions = [
          {
            label: 'Mr',
            value: 'Mr'
          },
          {
            label: 'Mrs',
            value: 'Mrs'
          },
          {
            label: 'Miss',
            value: ' Miss'
          }
        ];
        return (
          <div className="w-full coapplicant md:overflow-hidden overflow-auto px-0 pt-0 pb-2 md:p-2">
            <Form onSubmit={handleSubmit} className="w-full">
              <div
                className={`bg-white ${py2rem} ${md_py_0_25rem} ${py_0_5rem} `}
              >
                <div className="flex-1  w-full">
                  <p className="font-roboto font-normal text-grey-920 text-base ">
                    Gender
                  </p>
                  <div className={' w-full flex '}>
                    <div
                      className={
                        values.gender == 'Male' ? 'assignedImg' : 'assignImg'
                      }
                      onClick={() => setFieldValue('gender', 'Male')}
                    >
                      <img className="cursor-pointer px-2 " src={MaleImage} />
                    </div>
                    <div
                      className={
                        values.gender == 'Female' ? 'assignedImg' : 'assignImg'
                      }
                      onClick={() => setFieldValue('gender', 'Female')}
                    >
                      <img className="cursor-pointer px-2" src={Female} />
                    </div>
                    <div
                      className={
                        values.gender == 'Unspecified'
                          ? 'assignedImg'
                          : 'assignImg'
                      }
                      onClick={() => setFieldValue('gender', 'Unspecified')}
                    >
                      <img
                        className="cursor-pointer px-2"
                        src={common_gender}
                      />
                    </div>
                  </div>
                  {errors.gender ? (
                    <p className="text-red-100 pt-2">Required</p>
                  ) : null}

                  <div className={`block ${py_0_75rem} pb-8 md:pb-0`}>
                    <div className="w-full md:flex block">
                      <div className={`w-full md:w-6/12  ${py_0_75rem} `}>
                        <InputPrefixDropdown
                          legendName="First Name"
                          dropdownName="title"
                          name="firstName"
                          options={[...titleOptions]}
                          dropdownValue={values.title}
                          value={values.firstName}
                          onChangeDropdown={e => {
                            setFieldValue('title', e, true);
                          }}
                          onChange={e => {
                            handleChange(e);
                            setFieldValue('firstName', e.target.value);
                          }}
                          onBlur={e => {
                            handleBlur(e);
                          }}
                          error={touched.firstName && errors.firstName}
                          errorMsg={errors.firstName}
                          touched={touched.firstName}
                        />
                      </div>
                      <div
                        className={`w-full md:w-6/12 ${py_0_75rem} ${sm_py_1rem}   mr-auto md:ml-4`}
                      >
                        <CommonInput
                          name="lastName"
                          disabled=""
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.lastName}
                          stylesContainer={{
                            height: '52px',
                            maxWidth: '100%'
                          }}
                          legendName="Last Name"
                          error={touched.lastName && errors.lastName}
                          errorMsg={errors.lastName}
                          touched={touched.lastName}
                        />
                      </div>
                    </div>
                    <div className={`md:flex block ${md_py_0_5rem}`}>
                      <div className={`w-full md:w-6/12   ${md_py_0_75rem} `}>
                        <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                          DOB
                        </div>
                        <CommonDatePicker
                          styleHeight={{ height: '50px' }}
                          onChangeMonth={(value, isValidDate) => {
                            setFieldValue('month', value, true);

                            setFieldTouched('month', true, false);
                            if (!isValidDate) {
                              setFieldValue(
                                'date',
                                {
                                  value: '',
                                  label: 'Date'
                                },
                                true
                              );
                            }
                          }}
                          onChangeYear={(value, isValidDate) => {
                            setFieldValue('year', value, true);
                            setFieldTouched('year', true, false);

                            if (!isValidDate) {
                              setFieldValue(
                                'date',
                                {
                                  value: '',
                                  label: 'Date'
                                },
                                true
                              );
                            }
                          }}
                          onChangeDate={value => {
                            setFieldValue('date', value, true);
                            setFieldTouched('date', true, false);
                          }}
                          valueMonth={values.month}
                          valueYear={values.year}
                          valueDate={values.date}
                          errorYear={
                            touched.year && get(errors, 'year.value', false)
                          }
                          touchedYear={touched.year}
                          onBlurYear={() => {
                            setFieldTouched('year', true, true);
                          }}
                          errorMonth={
                            touched.month && get(errors, 'month.value', false)
                          }
                          touchedMonth={touched.month}
                          onBlurMonth={() => {
                            setFieldTouched('month', true, true);
                          }}
                          // errors.date.value
                          errorDate={
                            touched.date && get(errors, 'date.value', false)
                          }
                          touchedDate={touched.date}
                          onBlurDate={() => {
                            setFieldTouched('date', true, true);
                          }}
                          //  errorMsg= "DOB is not selected"git
                          type="dob"
                        />
                      </div>
                      <div
                        className={`w-full md:w-6/12  ${py_6rem} md:ml-4 relative`}
                      >
                        <div
                          style={{ marginTop: '17px' }}
                          className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md ml-4"
                        >
                          +91
                        </div>
                        <div>
                          <CommonInput
                            name="mobile"
                            id="mobile"
                            maxLength={10}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.mobile}
                            stylesContainer={{
                              height: '52px',
                              maxWidth: '100%'
                            }}
                            inputStyle={{
                              paddingLeft: '45px',
                              letterSpacing: '1px'
                            }}
                            onBlurStyle={{
                              paddingLeft: '20px'
                            }}
                            legendStyle={{
                              paddingLeft: errors.mobile ? '20px' : '20px'
                            }}
                            legendName="Mobile Number"
                            error={touched.mobile && errors.mobile}
                            //errorMsg={errors.mobile}
                            className={`pt-24`}
                            touched={touched.mobile}
                            // disabled
                            onKeyPress={e => {
                              //validate(e, inputLength);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={`md:flex block ${mt_container} `}>
                      <div className={`w-full md:w-6/12 ${mt_1_9rem} `}>
                        <CommonInput
                          name="email"
                          disabled=""
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          stylesContainer={{
                            height: '52px',
                            maxWidth: '100%'
                          }}
                          legendName="Email"
                          error={touched.email && errors.email}
                          errorMsg={errors.email}
                          touched={touched.email}
                        />
                      </div>

                      <div
                        className={`w-full md:w-6/12 mr-auto ${py_0_25rem} ${sm_py_0_75rem} md:ml-4 `}
                      >
                        <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                          Relationship with applicant
                        </div>

                        <CommonSelect sort={true}
                          name="relationship"
                          value={values.relationship}
                          onChange={e => {
                            setFieldValue('relationship', {
                              value: e.value,
                              label: e.value
                            });
                          }}
                          options={relationShipFilter}
                          isHoverEffect
                          stylesContainer={{
                            height: '52px',
                            marginBottom: '0px',
                            fontSize: '40px'
                          }}
                          dropdownStyle={{
                            top: '52px',
                            color: 'rgba(0,0,0,0.87)',
                            fontSize: '16px',
                            backgroundColor: '#fff',
                            alignItems: 'center',
                            fontFamily: 'Roboto',
                            fontWeight: 400
                          }}
                          styleText={{
                            fontSize: '14px',
                            padding: '0 25px'
                          }}
                          error={
                            touched.relationship &&
                            get(errors, 'relationship.value', false)
                          }
                          touched={touched.relationship}
                        />
                      </div>
                    </div>
                    <div className={`inline-flex flex-row pl-0 ${py_0_75rem}`}>
                      <input
                        className="mt-1  mr-3 "
                        type="checkbox"
                        // checked={checked}
                        name="terms"
                        id="terms"
                        value={values.terms}
                        onChange={e => handleCheckedChange(e)}
                      />
                      <div>
                        <p className="text-sm block mt-px">
                          Income to be Considered
                        </p>
                      </div>
                    </div>
                    <button
                      id="submit"
                      className={
                        'submitButton w-full md:w-56 capitalize' +
                        (!checked ? ' bg-grey-700' : ' bg-teal')
                      }
                      type="submit"
                      disabled={
                        isSubmitting ||
                        values.firstName == '' ||
                        values.lastName == '' ||
                        errors.firstName ||
                        errors.lastName ||
                        values.mobile == '' ||
                        values.email == '' ||
                        errors.mobile ||
                        errors.email ||
                        values.gender == '' ||
                        values.relationship == '' ||
                        errors.gender ||
                        errors.relationship ||
                        values.date == '' ||
                        values.month == '' ||
                        errors.date ||
                        errors.month ||
                        errors.year ||
                        errors.year
                      }
                    >
                      ADD CO-APPLICANT
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};
export default AddCoApplicant;
